<template>
  <!-- CSS命名参考BEM规范 -->
  <div class="navSettingPanel">
    <el-dialog title="自定义快捷菜单" :visible="true" :modal-append-to-body="false" :before-close="onDialogClose">
      <div class="navSettingPanel__container">
        <div>
          <div class="navSettingPanel__left">
            <div style="margin: 15px 0 20px 20px;">快速导航（拖拽排序）</div>
            <draggable v-model="checkList">
              <div v-for="(item,index) in checkObjList" v-if="item" class="navSettingPanel__sortItem" :key="index">
                <i class="icon" :class="item.icon" style="font-size: 15px;color: #aab1bb;"></i>
                <span style="margin-left: 16px;">{{ item.name }}</span>
                <i
                  class="el-icon-close close-icon"
                  @click="onRemoveLeftMenu(item)"
                  style="color: #4875f6; font-size: 11px;"
                ></i>
              </div>
            </draggable>
          </div>
          <div class="navSettingPanel__right">
            <div>
              <div class="navSettingPanel__tipInfo">当前快捷配置，只允许配置不超过8个快捷项</div>
            </div>
            <el-checkbox-group v-model="checkList" :min="1" :max="8">
              <div class="navSettingPanel__subPanel" v-for="(panel,index) in navTopMenu" :key="index">
                <div class="navSettingPanel__subPanelTitle">{{ panel.name }}</div>
                <el-checkbox
                  v-for="(item,index) in panel.children"
                  :label="item.href"
                  :key="index"
                  style="width: 150px; margin: 0 0 5px 0;"
                >{{ item.name }}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="onConfirm">确 定</el-button>
        <el-button size="small" @click="onDialogClose" >取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import mutationTypes from '../../store/mutation-types';

export default {
  components: {
    draggable
  },

  data() {
    return {
      checkList: []
    };
  },

  created() {
    this.init();
  },

  computed: {
    navLeftMenu: function () {
      return this.$store.state.navLeftMenu;
    },
    navTopMenu: function () {
      return this.$store.state.navTopMenu;
    },
    checkObjList() {
      let list = this.navTopMenu.reduce((sum, item) => {
        return sum.concat(item.children);
      }, []);
      if (list.length === 0 || this.checkList.length === 0) {
        return [];
      }
      let aa = this.checkList.map(item => {
        return list.find(o => o.href === item);
      });
      return aa;
    }
  },

  methods: {
    init() {
      let sideBarMenu = JSON.parse(sessionStorage.getItem("navLeftMenu")) || [];
      this.checkList = sideBarMenu.map(item => item.href);
    },

    onConfirm() {
      let navLeftMenu = this.checkObjList;
      this.$store.commit(mutationTypes.SET_NAV_LEFT_MENU, navLeftMenu);
      this.$emit("close");
    },

    onDialogClose() {
      this.$emit("close");
    },

    onRemoveLeftMenu(item) {
      if (this.checkList.length <= 1) {
        return;
      }
      this.checkList = this.checkList.filter(href => {
        return href !== item.href;
      });
    }
  }
};
</script>

<style scoped>
.navSettingPanel /deep/ .el-dialog {
  width: 900px;
}

.navSettingPanel__container {
  margin: 0 auto;
  font-size: 12px !important;
  color: #333;
  overflow: hidden;
}

.navSettingPanel__left {
  width: 199px;
  height: 385px;
  overflow-y: auto;
  padding: 0;
  background-color: #f1f3f5;
  display: block;
  float: left;
}

.navSettingPanel__sortItem {
  border: 1px dashed #4875f6;
  margin: 0 auto 10px auto;
  font-size: 12px;
  cursor: move;
  color: #181818;
  position: relative;
  height: 43px;
  line-height: 43px;
  width: 185px;
  padding-left: 12px;
}

.navSettingPanel__right {
  height: 385px;
  overflow-y: auto;
  display: block;
  width: 645px;
  padding-left: 10px;
  float: left;
}

.navSettingPanel__tipInfo {
  padding: 5px 15px;
  line-height: 20px;
  font-size: 12px;
  color: #ec670b;
  background: rgba(236, 103, 11, 0.05);
}

.navSettingPanel__subPanel {
  margin-top: 15px;
}

.navSettingPanel__subPanelTitle {
  margin-bottom: 5px;
}

.navSettingPanel__left .close-icon {
  position: absolute;
  cursor: pointer;
  right: 10px;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 12px;
  height: 12px;
  font-weight: 400;
  transform: scale(0.8);
}

.navSettingPanel__subPanel /deep/ .el-checkbox__label {
  font-size: 12px;
  padding-left: 8px;
}

.navSettingPanel__subPanel /deep/ .el-checkbox__inner {
  display: inline-block;
  position: relative;
  /* border: 1px solid #ccc; */
  border-radius: 0;
  box-sizing: border-box;
  width: 16px;
  height: 16px;
  /* background-color: #fff; */
  z-index: 1;
  transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
}

/*修改ElementUI样式*/
.el-checkbox-group {
  font-size: 12px;
}
</style>